import { render } from "./ReportDownload.vue?vue&type=template&id=de4827b2&scoped=true"
import script from "./ReportDownload.vue?vue&type=script&lang=js"
export * from "./ReportDownload.vue?vue&type=script&lang=js"

import "./ReportDownload.vue?vue&type=style&index=0&id=de4827b2&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4827b2"]])

export default __exports__